/* eslint-disable */

import { isEmail } from './modules/_Utils';

window.cfields = { 1: 'zip_code' };
window._show_thank_you = function (id, message, trackcmp_url, email) {
    var form = document.getElementById('_form_' + id + '_'),
        thank_you = form.querySelector('._form-thank-you');
    form.querySelector('._form-content').style.display = 'none';
    thank_you.innerHTML = message;
    thank_you.style.display = 'block';
    const vgoAlias =
        typeof visitorGlobalObjectAlias === 'undefined'
            ? 'vgo'
            : visitorGlobalObjectAlias;
    var visitorObject = window[vgoAlias];
    if (email && typeof visitorObject !== 'undefined') {
        visitorObject('setEmail', email);
        visitorObject('update');
    } else if (typeof trackcmp_url != 'undefined' && trackcmp_url) {
        // Site tracking URL to use after inline form submission.
        _load_script(trackcmp_url);
    }
    if (typeof window._form_callback !== 'undefined') window._form_callback(id);
};

window._load_script = function (url, callback) {
    var head = document.querySelector('head'),
        script = document.createElement('script'),
        r = false;
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.src = url;
    if (callback) {
        script.onload = script.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState == 'complete')) {
                r = true;
                callback();
            }
        };
    }
    head.appendChild(script);
};
(function () {
    if (window.location.search.search('excludeform') !== -1) return false;

    const form_to_submit = document.getElementById('_form_1_');
    const allInputs = form_to_submit.querySelectorAll('input');

    const hideAllErrors = function () {
        form_to_submit
            .querySelectorAll('._form-error')
            .forEach(function (field) {
                field.classList.add('hidden');
            });

        allInputs.forEach(function (input) {
            input.classList.remove('_has-error');
        });
    };

    allInputs.forEach(function (input) {
        input.addEventListener('input', function (e) {
            hideAllErrors();
        });
    });

    const getUrlParam = function (name) {
        const regexStr = '[?&]' + name + '=([^&#]*)';
        const results = new RegExp(regexStr, 'i').exec(window.location.href);
        return results ? decodeURIComponent(results[1]) : false;
    };

    for (let i = 0; i < allInputs.length; i++) {
        const regexStr = 'field\\[(\\d+)\\]';
        const results = new RegExp(regexStr).exec(allInputs[i].name);
        if (results) {
            allInputs[i].dataset.name = window.cfields[results[1]];
        } else {
            allInputs[i].dataset.name = allInputs[i].name;
        }
        var fieldVal = getUrlParam(allInputs[i].dataset.name);

        if (fieldVal) {
            if (allInputs[i].dataset.autofill === 'false') {
                continue;
            }
            allInputs[i].value = fieldVal;
        }
    }

    const validate_form = function () {
        let isValid = true;
        allInputs.forEach(function (input) {
            const inputValue = input.value;
            const errorField = form_to_submit.querySelector(
                `[data-for="${input.id}"]`
            );

            if (input.type === 'text') {
                if (!isEmail(inputValue)) {
                    errorField.innerHTML =
                        'Enter your email in format name@example.com';
                    errorField.classList.remove('hidden');
                    isValid = false;
                    input.classList.add('_has-error');
                } else {
                    errorField.innerHTML = '';
                    errorField.classList.add('hidden');
                    input.classList.remove('_has-error');
                }
            }
            if (input.type === 'tel') {
                if (inputValue.length !== 5) {
                    errorField.innerHTML = 'Enter your zip code';
                    errorField.classList.remove('hidden');
                    isValid = false;
                    input.classList.add('_has-error');
                } else {
                    errorField.innerHTML = '';
                    errorField.classList.add('hidden');
                    input.classList.remove('_has-error');
                }
            }
        });
        return isValid;
    };
    const form_submit = function (e) {
        e.preventDefault();
        if (validate_form()) {
            // use this trick to get the submit button & disable it using plain javascript
            document.querySelector('#_form_1_submit').disabled = true;

            const formValue = {
                u: 1,
                f: 1,
                c: 0,
                m: 0,
                s: '',
                act: 'sub',
                v: 2,
                email: form_to_submit.querySelector('#newsletter-email').value,
                'field[1]':
                    form_to_submit.querySelector('#newsletter-zip').value,
                jsonp: true,
            };

            const serialized = Object.keys(formValue)
                .map((key) => `${key}=${formValue[key]}`)
                .join('&');

            _load_script(
                'https://highspeedinternet.activehosted.com/proc.php?' +
                    serialized
            );
        }
        return false;
    };
    form_to_submit.addEventListener('submit', form_submit);
})();
